function authController($localStorage, $state, $scope, WS, AppSettings, $http, Flash, $sce) {
    'ngInject';
    const vm = this;

    vm.access = {}

    function handleLoginSuccess(data) {
        $localStorage.user = data.user;
        if (data.user.email_verifie == 0) {
            $localStorage.inviteToLogin = true;
        }
        $localStorage.role = data.role;
        $localStorage.dashboard = data.user.dashboard;

        if (data.access_token && data.token_type) {
            $localStorage.accessToken = data.token_type + ' ' + data.access_token;
            document.cookie = "accessToken=" + data.token_type + ' ' + data.access_token;
        }

        var role = $localStorage.role.code;
        if (role == 'admin' || role == 'superviseur' || role == 'commercial' || role == 'dawarji') {
            if ($localStorage.dashboard == 'vente') {
                $state.go('app.dashboard', {}, { reload: false, inherit: false });
            } else {
                $state.go('app.dashboardcommande', {}, { reload: false, inherit: false });
            }
        } else if (role == 'magasinier') {
            $state.go('app.users.listusers', {}, { reload: true });
        } else if (role == 'caissier') {
            $state.go('app.chargements.stat-chargements', {}, { reload: true });
        } else if (role == 'responsable_vente') {
            $state.go('app.bl.index', {}, { reload: true });
        } else if (role == 'fournisseur') {
            $state.go('app.stockDepot.index', {}, { reload: true });
        } else {
            $state.go('app.clients.index', {}, { reload: true });
        }
    }

    vm.login = function() {
        WS.post('login', vm.access)
            .then(function(response) {
                if (response.status == 200) {
                    handleLoginSuccess(response.data);
                }
            }, function(error) {
                Flash.create('danger', error.data.message);
                $scope.$apply();
            });
    };

    vm.verifyOtp = function() {
        WS.post('verify-2fa', {
            user_id: vm.userId,
            code: vm.otpCode
        }).then(function(response) {
            if (response.status == 200) {
                handleLoginSuccess(response.data);
            }
        }, function(error) {
            Flash.create('danger', error.data.message);
            $scope.$apply();
        });
    };

    vm.login2FA = function() {
        WS.post('login2fa', vm.access)
            .then(function(response) {
                if (response.status == 200) {
                    if (response.data.require_2fa_setup) {
                        vm.showOtpForm = true;
                        vm.userId = response.data.user_id;
                        vm.secret = response.data.secret;
                        vm.qrCode = $sce.trustAsHtml(response.data.qr);
                    } else {
                        handleLoginSuccess(response.data);
                    }
                    $scope.$apply();
                }
            }, function(error) {
                Flash.create('danger', error.data.message);
                $scope.$apply();
            });
    };

    vm.loginEmail = function() {
        WS.post('login-email-2fa', vm.access)
            .then(function(response) {
                if (response.status == 200) {
                    if (response.data.require_email_otp) {
                        vm.showEmailOtpForm = true;
                        vm.userId = response.data.user_id;
                        Flash.create('success', 'Un code de vérification a été envoyé à votre adresse email.');

                    } else {
                        handleLoginSuccess(response.data);
                    }
                    $scope.$apply();
                }
            }, function(error) {
                Flash.create('danger', error.data.message);
                $scope.$apply();
            });
    };

    vm.verifyEmailOtp = function() {
        WS.post('verify-email-2fa', {
            user_id: vm.userId,
            code: vm.emailOtpCode
        }).then(function(response) {
            if (response.status == 200) {
                handleLoginSuccess(response.data);
            }
        }, function(error) {
            Flash.create('danger', error.data.message);
            $scope.$apply();
        });
    };

    vm.resetQrCode = function() {
        WS.post('reset-2fa-by-email', vm.access)
        .then(function(response) {
            if (response.status == 200) {
                vm.showOtpForm = true;
                vm.showEmailOtpForm = false;
                Flash.create(
                  'success',
                  'Consultez votre email et ajoutez le code secret dans votre application Google Authenticator.'
                );
                $scope.$apply();
            }
        }, function(error) {
            Flash.create('danger', error.data.message);
            $scope.$apply();
        });
    };

    vm.loginForm = () => {
        if (AppSettings.securiteAuth === '2FA') {
            vm.login2FA();
        } else if (AppSettings.securiteAuth === 'Email') {
            vm.loginEmail();
        } else {
            vm.login();
        }
    }



    WS.getData('infoc')
        .then(function (response) {
            vm.societes = response.data;
            var contrat_code = vm.societes.contrat;
            /*console.log(response);
            console.log(contrat_code);*/
            $http({
                method: 'GET',
                url: `https://api.sav.priorityexpeditions.com/api/v1/license/${contrat_code}`,
                //url: `https://api.sav.priorityexpeditions.com/api/v1/license/nomadis`,
                cache: false
            }).then(function successCallback(response) {
                //console.log($.isEmptyObject(response.data));
                //console.log('-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_Contrat_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-');


                vm.url_pub = response.data.url_pub;
                vm.texte_pub = response.data.texte_pub;

                vm.existBi = (vm.linkBi) ? true : false;
                if ($.isEmptyObject(response.data) == true) {
                    vm.expiration = true;
                    vm.expirationErrorContrat = true;
                    vm.alertExpiration = `Erreur de vérification de compte, veuillez contacter l'admin.`;
                } else {
                    //response.isactif="0";
                    if (response.data.isactif == "1") {
                        var currentday = new moment();
                        var lastday = moment(response.data.date_fin, "YYYY-MM-DD");
                        //Difference in number of days
                        var restime = moment.duration(lastday.diff(currentday)).asDays();
                        var restime = Number(restime.toFixed(0));
                        //console.log(restime);
                        //restime = 0;
                        if (restime <= 7 && restime > 0) {
                            vm.expiration = true;
                            vm.alertExpiration = `Il Vous reste ${restime} jours avant l'expiration de votre compte.`;
                        }
                        if (restime <= 0) {
                            vm.expiration = true;
                            vm.alertExpiration = `Votre compte a été expiré.`;
                        }
                    }
                    //console.log('-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_Contrat_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-');

                    else {
                        vm.expiration = true;
                        vm.alertExpiration = `Votre compte a été désactivé.`;
                    }
                    //console.log('-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_Contrat_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-');
                }
            }, function errorCallback(response) {
                vm.expiration = true;
                vm.expirationErrorContrat = true;
                vm.alertExpiration = `Erreur de verification de compte, veuillez contacter l'admin.`;
            });
        });

}
export default {
    name: 'authController',
    fn: authController
};
